import PropTypes from "prop-types"

import StoryCard from "shared/components/get_more/story_card"
import GetMoreServiceCard from "./service_card"
import GetMoreAppletCard from "./applet_card"
import {
  connectionShape,
  partialStoryShape,
  serviceShape,
} from "app/lib/shared_prop_types"
import { attachNewBadgeForButtons } from "shared/scripts/new_badge_button.tsx"

export const GetMoreSection = ({
  currentView,
  section: {
    applets,
    services,
    stories,
    appletsOffset,
    servicesOffset,
    storiesOffset,
  },
  diyPath,
}) => {
  if (appletsOffset < 2) {
    attachNewBadgeForButtons()
  }

  // We need to get the position of elements on the screen, so each content type has an offset.
  return (
    <>
      {appletsOffset < 2 && (
        <a
          className="get-more cta-your-own-applet"
          data-allow-new-badge="header_create_cta"
          data-track-ifttt-next-event="click"
          data-track-data={JSON.stringify({
            object_type: "diy_create_button",
            location_type: "discover",
          })}
          href={diyPath}
        >
          <span>Make your own from scratch</span>
          <button className="button-tertiary">Create</button>
        </a>
      )}
      {["discover_all", "discover_stories"].includes(currentView) &&
        stories.length > 0 && (
          <StoryCard
            story={stories[0]}
            position={storiesOffset}
            singleStoryBasePath="explore"
            locationType="discover"
          />
        )}
      {["discover_all", "discover_applets"].includes(currentView) && (
        <ul className="web-applet-cards get-more">
          {applets.slice(0, 2).map((applet, idx) => {
            return (
              <GetMoreAppletCard
                applet={applet}
                key={idx}
                position={appletsOffset + idx}
              />
            )
          })}
        </ul>
      )}
      {["discover_all", "discover_services"].includes(currentView) && (
        <ul className="service-cards get-more">
          {services.map((service, idx) => {
            return (
              <GetMoreServiceCard
                service={service}
                key={idx}
                position={servicesOffset + idx}
              />
            )
          })}
        </ul>
      )}
      {["discover_all", "discover_stories"].includes(currentView) &&
        stories.length > 1 && (
          <StoryCard
            story={stories[1]}
            position={storiesOffset + 1}
            singleStoryBasePath="explore"
          />
        )}
      {["discover_all", "discover_applets"].includes(currentView) && (
        <ul className="web-applet-cards get-more">
          {applets.slice(2, 4).map((applet, idx) => {
            return (
              <GetMoreAppletCard
                applet={applet}
                key={idx}
                position={appletsOffset + idx + 2}
              />
            )
          })}
        </ul>
      )}
    </>
  )
}

GetMoreSection.propTypes = {
  currentView: PropTypes.string,
  section: PropTypes.shape({
    applets: PropTypes.arrayOf(connectionShape).isRequired,
    services: PropTypes.arrayOf(serviceShape).isRequired,
    stories: PropTypes.arrayOf(partialStoryShape).isRequired,
    servicesOffset: PropTypes.number,
    appletsOffset: PropTypes.number,
    storiesOffset: PropTypes.number,
  }).isRequired,
  onAppletClick: PropTypes.func,
  diyPath: PropTypes.string,
}

GetMoreSection.defaultProps = {
  section: {
    applets: [],
    stories: [],
    services: [],
  },
}
